import React, { useRef } from 'react';
import { degToRad, formatNumber, calculateSliceSize } from '../../lib/ep.js';
import { Stage, Layer, Rect, Circle, Line } from 'react-konva';

import ActionButton from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import FloatingLayer from '../builder/FloatingLayer';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';

const white_color = '#FFFFFF';
const gray_color = '#363636';

const RouletteSliceTemplateLayer = (props) => {
	const num_slices = props?.num_slices ?? false;
	if(!num_slices) return null;

	let refs = useRef([]);

	const export_radius = 300;
	const logo_radius_export = export_radius / 6;

	const slice_specs = calculateSliceSize(export_radius, num_slices);
	const _angle  = slice_specs.angle;
	const _width  = slice_specs.width;
	const _height = slice_specs.height;

	const slice_shape_export_props = (context, shape) => {
		context.beginPath();
		context.moveTo(0, 0);
		context.arc(0, 0, export_radius, 0, degToRad(_angle));
		context.closePath();
		context.fillStrokeShape(shape);
	};

	const downloadRouletteView = () => {
		var link = document.getElementById('download_link');
		link.setAttribute('download', 'slice_template.png');
		link.setAttribute('href', refs.current['slice_image_template_ref'].toDataURL({ pixelRatio:3 }).replace(/^data:image\/[^;]/, 'data:application/octet-stream'));
		link.click();
	}

	return (
		<FloatingLayer _class={{size:'auto'}} backButton={props.close}>
			<div>
				<SectionTitle>Template to design the segment image</SectionTitle>
				<div class="roulette_slices_template" style={{width:'calc(' + (_width + 290) + 'px + 1em)'}}>
					<div>
						<div>
							<SectionSubtitle>From this section, you can design the image of the segments of the Prize wheel.</SectionSubtitle>
							<SectionSubtitle>In order to help you design the segment image, we provide you a template in PNG format, which you can use as a guide with your image editing software to make sure that the design of the segments fits perfectly the space available in the wheel.</SectionSubtitle>
							<SectionSubtitle _class={{other:'gui_force_bold'}}>Important: We recommend downloading the template once you have configured the final number of segments of the wheel, since in case of modifying the number of segments, the image template will also change.</SectionSubtitle>

							<div class="img_specs">{_width}×{_height}px (<span style={{fontSize:'1.6em', lineHeight:'0.2em', position:'relative', top:'0.08em'}}>⦡</span>: {formatNumber(_angle, 2)}º)</div>
						</div>
					</div>

					<div class="img_template">
						<Stage ref={(node) => { refs.current['slice_image_template_ref'] = node; }} width={_width} height={_height}>
							<Layer>
								<Rect
									width={_width}
									height={_height}
									fill={gray_color}
								/>

								<Circle
									radius={export_radius}
									stroke={white_color}
									strokeWidth={1}
									x={_width / 2}
									y={_height}
								/>

								<Rect
									sceneFunc={slice_shape_export_props}
									fill={white_color}
									rotation={-90 - _angle / 2}
									x={_width / 2}
									y={_height}
								/>

								<Circle
									radius={(export_radius - logo_radius_export) * 0.5 + logo_radius_export}
									stroke={gray_color}
									strokeWidth={1}
									x={_width / 2}
									y={_height}
								/>

								<Line
									points={[_width / 2, 0, _width / 2, export_radius]}
									stroke={gray_color}
									strokeWidth={1}
								/>

								<Circle
									radius={logo_radius_export}
									stroke={white_color}
									strokeWidth={1}
									fill={gray_color}
									x={_width / 2}
									y={_height}
								/>
							</Layer>
						</Stage>
					</div>
				</div>

				<ButtonCollection in_floating={true}>
					<a id="download_link" style={{display:'none'}} />

					<ActionButton
						icon='knk-download'
						onClick={() => downloadRouletteView()}
					>Download template</ActionButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

export default RouletteSliceTemplateLayer;